
<div [formGroup]="driverForm">
  <div class="p-0" >
  
    <div class="row">
      <div class="col-md-11">
        <h3>Edit Stop</h3>
      </div>
      <div class="col-md-1">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
   
    </div>

    <div  style="width: 100%;border-top: 5px solid #dee2e6 !important;" class="mt-2 mb-3"></div>
    <div class="row mt-2">
    <div class="col-md-6">
      <mat-form-field
      appearance="outline"
      class="w-100"
      floatLabel="always"
     
    >
      <mat-label class="custom-label" *ngIf="isPickup">Pickup</mat-label>
      <mat-label class="custom-label" *ngIf="isDrop">Drop</mat-label>
      <input
       formControlName="taskid"
        matInput
        [(ngModel)]="this.taskid"
        readonly
        
      />
    </mat-form-field>  
    
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <select class="form-select" formControlName="status" aria-label="Floating label select example">
          <option value="unassigned">Unassigned</option>                      
          <option value="assigned">Assigned</option>
          <option value="acknowledged">Aknowledged</option>
          <option value="inprogress">Started</option>
          <option value="completed">Completed</option>                      
        </select>
        <label for="floatingSelect">Task Status</label>
      </div>


      <!-- <div class="form-floating">
        <select class="form-select" formControlName="assignedto" aria-label="Floating label select example" [(ngModel)]="this.selectedValue">
        <option value="unassigned">Unassigned</option>
        <option value="assigned">Assigned</option> 
        <option value="acknowledged">Acknowledged</option>
        <option value="completed">Completed</option> 
        <option value="inprogress">Started</option>                      
        </select>
        <label for="floatingSelect">Task Status</label>
       
      </div> -->
       <!-- <div class="form-floating">
      <select class="form-select" id="floatingSelect" aria-label="Floating label select example">
        <option selected>Open this select menu</option>
        <option value="1">One</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div> -->
  
  
  </div>
    </div>
</div>
<div class="modal-body p-0 mt-3">
<div class="row mb-3">
    <div class="col-6">
        <mat-form-field
        appearance="outline"
        class="w-100"
        floatLabel="always"
     
       
      >
        <mat-label class="custom-label">Client Name</mat-label>
        <input
        formControlName="name"
          matInput
          [(ngModel)]="this.client"
          readonly
        />
      </mat-form-field>
    </div>
    <div class="col-6">
        <mat-form-field
        appearance="outline"
        class="w-100"
        floatLabel="always"
      
      >
        <mat-label class="custom-label">Contact Number</mat-label>
        <input
        formControlName="contact"
          matInput
          [(ngModel)]="this.contact"
        />
      </mat-form-field>
    </div>
</div>
<div class="row mb-3">
    <div class="col-12">

      <mat-form-field
      appearance="outline"
      class="w-100"
      floatLabel="always"
     
    >
      <mat-label class="custom-label">Address</mat-label>
      <input
        #inputField
        matInput
        formControlName="pickupLocation"
        [(ngModel)]="this.pickLocation"
        [placeholder]="placeholder"
      />
    </mat-form-field>
      
    </div>
</div>
<div class="row mb-3">
    <div class="col-md-6">
      <label for="dp">Date:</label>
      <input type="text" class="form-control" formControlName="date" id="dp" placeholder="Choose a date" bsDatepicker  [(ngModel)]="this.formattedDate" >
    </div>
    <div class="col-md-6">
      <label for="tp">Time:</label>
      <input type="text" class="form-control" id="tp" placeholder="Choose a time" bsTimepicker>
    </div>
</div>
<div class="row mb-3" >
    <div class="col-12">
        <mat-form-field
        appearance="outline"
        class="w-100"
        floatLabel="always"
       
      >
        <mat-label class="custom-label">Description</mat-label>
        <input
          formControlName="description"
          matInput
          
        />
      </mat-form-field>
    </div>
</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="this.closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="update()">Update Stop</button>
    
</div>
</div>

